import React, { useState } from "react";
import { IconDownload, IconLoader2 } from "@tabler/icons-react";
import Swal from "sweetalert2";

/**
 * Botão "Exportar CSV" para usar no header de cada BlockSection.
 * Recebe uma função async `onExport` que dispara o download.
 * Estado de loading é gerenciado internamente pra evitar duplo-click.
 */
const ExportCSVButton = ({ onExport, label = "Exportar Excel", disabled = false }) => {
  const [downloading, setDownloading] = useState(false);

  const handleClick = async (e) => {
    e?.stopPropagation();
    if (downloading || disabled) return;
    setDownloading(true);
    try {
      await onExport();
    } catch (err) {
      const msg =
        err?.response?.status === 429
          ? "Muitas tentativas. Aguarde alguns instantes."
          : err?.message || "Não foi possível exportar este relatório.";
      Swal.fire({
        icon: "error",
        title: "Falha no export",
        text: msg,
        confirmButtonColor: "#3b82f6",
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      type="button"
      className="insights-export-btn"
      onClick={handleClick}
      disabled={downloading || disabled}
      aria-busy={downloading}
      title="Baixar relatório em Excel (.xlsx)"
    >
      {downloading ? (
        <IconLoader2 size={14} className="insights-export-btn__spin" />
      ) : (
        <IconDownload size={14} />
      )}
      <span>{downloading ? "Gerando..." : label}</span>
    </button>
  );
};

export default ExportCSVButton;
